<template>
	<div class="footer">
            <div class="top_area">
                <div class="footer_container">
                    <ul>
                        <li><a href="http://www.eduwill.net/common/company/ceo.asp?_ga=2.21928956.677675565.1618813338-1612956875.1617795297&amp;_gl=1*cuxxa8*_ga*MTYxMjk1Njg3NS4xNjE3Nzk1Mjk3*_ga_C07Q38FFTL*MTYxODkwMTM2MS4zMi4xLjE2MTg5MDE0MjEuNjA."
                                target="_blank" title="새 창 열림"><span>회사소개</span> </a></li>
                        <li><a href="https://company.eduwill.net/main/terms"
                                target="_blank" title="새 창 열림"><span>이용약관</span> </a></li>
                        <li><a href="https://company.eduwill.net/main/privacy"
                                target="_blank"><span>개인정보처리방침</span> </a></li>
                    </ul>
                    <div class="top"><a id="moveTop"><span>TOP</span> </a></div>
                </div>
            </div>
            <div class="info">
                <div class="footer_container">
                    <div class="fr clearfix">
                        <a href="https://www.facebook.com/eduwillnet" class="ic_facebook" target="_blank"></a>
                        <a href="https://blog.eduwill.net/" class="ic_blog" target="_blank"></a>
                        <div class="sitemap">
                            <a class="btn_sitemap" onclick="">패밀리 사이트</a>
                            <div class="list">
                                <ul>
                                    <li><a href="http://www.eduwill.net/" target="_blank" title="새 창 열림">자격증/공무원 온라인</a>
                                    </li>
                                    <li><a href="http://www.eduwill.net/" target="_blank" title="새 창 열림">자격증/공무원
                                            직영학원</a></li>
                                    <li><a href="http://book.eduwill.net/" target="_blank" title="새 창 열림">에듀윌 도서몰</a>
                                    </li>
                                    <li><a href="http://www.studywill.net/" target="_blank" title="새 창 열림">원격평생교육원</a>
                                    </li>
                                    <li><a href="http://free.eduwill.net/main/main.will" target="_blank"
                                            title="새 창 열림">지식발전소</a></li>
                                    <li><a href="http://dream.eduwill.net/" target="_blank" title="새 창 열림">대관 서비스</a>
                                    </li>
                                    <li><a href="http://studio.eduwill.net/" target="_blank" title="새 창 열림">이러닝 스튜디오</a>
                                    </li>
                                    <li><a href="http://recruit.eduwill.net/" target="_blank" title="새 창 열림">에듀윌 채용</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="fl">
                        <div class="eduwill_info">
                            상호명 및 호스팅 제공자: ㈜ 에듀윌 | 대표이사 양형남 | e-mail : b2b@eduwill.net |원격평생교육시설신고 제 207호<br>

                            본사 : 서울시 구로구 디지털로34길 55 코오롱싸이언스밸리 2차 310호<br>

                            사업자등록번호 119-81-54852 | 대표전화 : 1600-6700 | 개인정보 보호책임자 : 황영준<br>

                            법인등록번호 110111-2450031 | 출판사등록번호 제 18-102호 | 통신판매신고 구로 제 2008-00077호<br>
                            <br>
                            Copyright ⓒ (주)에듀윌 Corp. All rights reserved.
                            <!-- <ul>
                            <li class="ic_loc">본사 : 서울시 구로구 디지털로34길 55 코오롱싸이언스밸리 2차 310호</li>
                            <li class="ic_mail">전화 : 1600-3700 (평일:09:00~21:00, 주말/공휴일 09:00~17:00)</li>
                            <li class="copy">copyright © (주)에듀윌 Corp.All rights reserved</li>
                        </ul> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import eventBus from "@/eventBus/event-bus";

export default {
	name: "CommonFooter",

	data() {
		return {
		}
	},

	computed: {
	},

	methods: {
		moveTop() {
			$('html, body').animate({
				scrollTop : 0
			}, 400);
		},
		sitemapToggle() {
			$(".sitemap").toggleClass("on");
		}
	},

	created() {
	},
	beforeMount() {
	},
	mounted() {
		const popupNum = this.$route.query.popup;
		popupNum && eventBus.$emit("show-counsel", popupNum, 'full');
	},
}
</script>

<style scoped>

</style>
